const HPAppDetailTypes = {
    TermSetTypes: {
        Default: 1,
        BuyDown: 2,
    },
    Programs: {
        WRCOG: 1,
        SANBAG: 2,
        LACounty: 3,
        MCED: 4,
        FDFC: 5,
        CSCDA: 6,
    },
};

export default HPAppDetailTypes;



// WEBPACK FOOTER //
// ./src/app/config/app.appDetail.config.js